import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
import "@styles/react/libs/swiper/swiper.scss";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
const params = {
  spaceBetween: 30,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: false,
  navigation: true,
};
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";

const PhotosGallery = ({ datas, t }) => {
  const createMarkup = (html) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };
  const shareUrl = window.location.href;
  const photos = datas?.Topic;
  const galleries = photos?.photos;
  const renderPhotos = () => {
    return (
      photos &&
      galleries.map((item, i) => {
        return (
          <SwiperSlide key={i}>
            <img
              src={item.file && item.file}
              alt="swiper 1"
              className="mt-2"
              style={{ borderRadius: "30px", height: "300px", width: "60%" }}
            />
          </SwiperSlide>
        );
      })
    );
  };
  const full_name =
    datas &&
    datas.Topic.created_by_user &&
    datas.Topic.created_by_user?.first_name +
      " " +
      datas.Topic.created_by_user?.last_name;

  return (
    <div style={{ position: "sticky", textAlign: "center" }}>
      <div className="blog-det-banner">
        <img
          width="100%"
          height="500px"
          src={photos?.photo_file && photos.photo_file}
          alt="blog-details"
        />
        <div className="blog-det-content">
          <div className="blog-det-title">
            <div className="mail-body">
              <div className="mail-message">
                <h2 className="text-truncate mb-0" style={{ color: "white" }}>
                  {photos?.title}
                </h2>
              </div>
            </div>
          </div>
          <ul className="blog-det-meta">
            <li>
              <i className="far fa-user"></i>
              <p>
                {t("By")}{" "}
                <Link
                  to={`/Gallery/Photos/topics/created_by/${datas?.Topic?.created_by_user?.id}`}
                >
                  {full_name}
                </Link>
              </p>
            </li>
            <li>
              <i className="far fa-calendar-alt"></i>
              <p> {photos?.date} </p>
            </li>
            <li>
              <i className="far fa-comments"></i>
              <p>
                {photos?.commentsCount} {t("Comments")}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div
        className="blog-det-descrip content-fluid"
        style={{ textAlign: "left" }}
      >
        <div
          className="preview"
          dangerouslySetInnerHTML={createMarkup(photos?.details)}
        ></div>
      </div>
      {galleries?.length === 0 ? (
        <h3 className="mt-2">{t("No gallery Exist")} </h3>
      ) : (
        <Swiper {...params}>{renderPhotos()}</Swiper>
      )}
      <div className="blog-det-navigate mt-5">
        <div className="navigate-post">
          {!datas?.Previous || datas?.Previous.length === 0 ? (
            <h4> {t("no previous post")} </h4>
          ) : (
            <div>
              <img
                width="100%"
                height="200px"
                src={
                  datas?.Previous.photo_file &&
                  datas?.Previous.photo_file
                }
              />
              <div className="mail-body">
                <div className="mail-message">
                  <h4 className="text-truncate">
                    <p style={{ color: "white" }}>
                      {datas?.Previous.title}
                    </p>
                  </h4>
                </div>
              </div>
              <Link
                to={`/Gallery/Photos/topics/${datas?.Previous?.id}`}
                className="prev-arrow"
              >
                <i className="fa fa-long-arrow-left"></i>
                {t("Previous Post")}
              </Link>
            </div>
          )}
        </div>
        <div className="navigate-post">
          {!datas?.Next || datas?.Next.length === 0 ? (
            <h4> {t("no next post")} </h4>
          ) : (
            <div>
              <img
                width="100%"
                height="200px"
                src={
                  datas?.Next.photo_file && datas?.Next?.photo_file
                }
              />
              <div className="mail-body">
                <div className="mail-message">
                  <h4 className="text-truncate">
                    <p style={{ color: "white" }}>{datas?.Next.title}</p>
                  </h4>
                </div>
              </div>
              <Link
                to={`/Gallery/Photos/topics/${datas?.Next?.id}`}
                className="next-arrow"
              >
                {t("Next post")}
                <i className="fa fa-long-arrow-right"></i>
              </Link>
            </div>
          )}
        </div>
      </div>

      {photos && (
        <div className=" mt-2 mb-0">
          <h3>{t("Share on")} </h3>
          <ul className="blog-icon">
            <li>
              <FacebookShareButton url={shareUrl}>
                <FacebookIcon size={30} round={true} />
              </FacebookShareButton>
            </li>

            <li>
              <TwitterShareButton url={shareUrl}>
                <TwitterIcon size={30} round={true} />
              </TwitterShareButton>
            </li>
            <li>
              <WhatsappShareButton url={shareUrl}>
                <WhatsappIcon size={30} round={true} />
              </WhatsappShareButton>
            </li>
            <li>
              <FacebookMessengerShareButton url={shareUrl}>
                <FacebookMessengerIcon size={30} round={true} />
              </FacebookMessengerShareButton>
            </li>
            <li>
              <EmailShareButton>
                <EmailIcon size={30} round={true} />
              </EmailShareButton>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default PhotosGallery;
